import {
    Airplay,
    Box,
    TrendingUp,
    Package,
    List,
    Image as ImageIcon,
    Target,
    TicketPercent,
    Star,
    Blocks,
    User,
    Users,
    UserX,
    BarChart3,
    BotMessageSquare,
    UploadCloud,
    Bell,
    BookOpen,
    Layers,
    Newspaper,
    MessageSquare,
    ShoppingBag,
    Flag,
    FileText,
    Video,
    ClipboardList,
    ShieldCheck,
    Gift,
    Ticket,
    Sparkles,
    Smartphone,
    BadgePercent,
    ReceiptIndianRupee,
    ReceiptText,
    SlidersHorizontal,
    Tags,
    UserPlus,
} from "lucide-react";
import { BULK_TOOL_MODULES } from "../../helpers/permissions";

// `permission` hides an item from admins whose role lacks it (see
// isAllowed in context/usePermissions). Groups with no visible child hide too.

export const MENU_ITEMS = [
    {
        key: "dashboard",
        label: "Dashboard",
        icon: Airplay,
        url: "/dashboard",
    },
    {
        key: "analytics",
        label: "Analytics",
        icon: BarChart3,
        url: "/analytics",
        permission: "analytics",
    },
    {
        key: "assistant-insights",
        label: "Assistant Insights",
        icon: BotMessageSquare,
        url: "/assistant-insights",
        permission: "assistantInsights",
    },
    {
        key: "users",
        label: "Manage Users",
        icon: Users,
        url: "/users",
        permission: "users",
    },
    {
        key: "account-deletions",
        label: "Deletion Requests",
        icon: UserX,
        url: "/account-deletions",
        permission: "accountDeletion",
    },
    {
        key: "waitlist",
        label: "Waitlist",
        icon: ClipboardList,
        url: "/waitlist",
        permission: "waitlist",
    },
    {
        key: "notifications",
        label: "Notifications",
        icon: Bell,
        url: "/notifications",
        permission: "notifications",
    },
    {
        key: "marketplace-group",
        label: "Marketplace",
        icon: ShoppingBag,
        children: [
            {
                key: "brand",
                label: "Manage Brands",
                icon: Box,
                url: "/brand",
                permission: "brand",
            },
            {
                key: "category",
                label: "Manage Categories",
                icon: List,
                url: "/category", // list page
                permission: "category",
            },
            {
                key: "product",
                label: "Manage Products",
                icon: Package,
                url: "/product",
                permission: "product",
            },
            {
                key: "product-coupon",
                label: "Manage Product Coupons",
                icon: TicketPercent,
                url: "/product-coupon",
                permission: "coupon",
            },
        ],
    },
    {
        key: "goals-group",
        label: "Goals",
        icon: Flag,
        children: [
            {
                key: "goal-category",
                label: "Manage Goal Categories",
                icon: Blocks,
                url: "/goal-category", // list page
                permission: "goalCategory",
            },
            {
                key: "custom-goal",
                label: "Manage Custom Goal",
                icon: Target,
                url: "/custom-goal",
                permission: "customGoal",
            },
        ],
    },
    {
        key: "content-group",
        label: "Content",
        icon: FileText,
        children: [
            {
                key: "banner",
                label: "Manage Banners",
                icon: ImageIcon,
                url: "/banner",
                permission: "banner",
            },
            {
                key: "feature",
                label: "Manage FAQs",
                icon: Star,
                url: "/pages/faqs",
                permission: "faq",
            },
            {
                key: "feature video",
                label: "Feature Videos & Reels",
                icon: Video,
                url: "/pages/feature-video",
                permission: "featureVideo",
            },
            {
                key: "boarding",
                label: "Manage Onboarding Q&A",
                icon: ClipboardList,
                url: "/boarding-system", // list page
                permission: "onboardingQA",
            },
        ],
    },
    {
        key: "blog-group",
        label: "Blog",
        icon: Newspaper,
        children: [
            {
                key: "blog-category",
                label: "Blog Categories",
                icon: BookOpen,
                url: "/blog-category",
                permission: "blogCategory",
            },
            {
                key: "blog-subcategory",
                label: "Blog Sub-categories",
                icon: Layers,
                url: "/blog-subcategory",
                permission: "blogSubCategory",
            },
            {
                key: "blog-posts",
                label: "Blog Posts",
                icon: Newspaper,
                url: "/blog-posts",
                permission: "blogPost",
            },
            {
                key: "blog-comments",
                label: "Blog Comments",
                icon: MessageSquare,
                url: "/blog-comments",
                permission: "blogComment",
            },
        ],
    },
    {
        key: "rewards-group",
        label: "Rewards",
        icon: Gift,
        children: [
            {
                key: "reward-coupons",
                label: "Reward Coupons",
                icon: Ticket,
                url: "/reward-coupons",
                permission: "rewardCoupons",
            },
            {
                key: "scratch-rules",
                label: "Scratch Card Rules",
                icon: Sparkles,
                url: "/scratch-rules",
                permission: "rewardRules",
            },
            {
                key: "referrals",
                label: "Referrals",
                icon: UserPlus,
                url: "/referrals",
                permission: "referral",
            },
        ],
    },
    {
        key: "billpay-group",
        label: "Recharge & Bills",
        icon: Smartphone,
        children: [
            {
                key: "billpay-charges",
                label: "Convenience Fees",
                icon: BadgePercent,
                url: "/billpay-charges",
                permission: "billpayCharges",
            },
            {
                key: "billpay-orders",
                label: "Orders",
                icon: ReceiptIndianRupee,
                url: "/billpay-orders",
                permission: "billpayOrders",
            },
            {
                key: "billpay-invoices",
                label: "Invoices",
                icon: ReceiptText,
                url: "/billpay-invoices",
                permission: "billpayInvoices",
            },
            {
                key: "billpay-settings",
                label: "Settings",
                icon: SlidersHorizontal,
                url: "/billpay-settings",
                permission: "billpaySettings",
            },
        ],
    },
    {
        key: "voucher-offers",
        label: "Voucher Offers",
        icon: Tags,
        url: "/voucher-offers",
        permission: "voucherOffers",
    },
    {
        key: "spend-tracker",
        label: "SpendTracker Categories",
        icon: TrendingUp,
        url: "/spend-tracker",
        permission: "spendTrackerCategory",
    },
    {
        key: "bulk-tools",
        label: "Bulk Import/Export",
        icon: UploadCloud,
        url: "/bulk-tools",
        permission: BULK_TOOL_MODULES,
    },
    {
        key: "admin",
        label: "Manage Staff",
        icon: User,
        url: "/admin",
        permission: "admins",
    },
    {
        key: "roles",
        label: "Roles & Permissions",
        icon: ShieldCheck,
        url: "/roles",
        permission: "roles",
    },
];

export const HORIZONTAL_MENU_ITEM = [
    {
        key: "dashboard",
        label: "Dashboard",
        icon: "ri:airplay-line",
        url: "/dashboard",
    },
    {
        key: "admin",
        label: "Admin",
        icon: "ri:user-line",
        url: "/admin",
        permission: "admins",
    },
    {
        key: "roles",
        label: "Roles & Permissions",
        icon: "ri:shield-user-line",
        url: "/roles",
        permission: "roles",
    },
    {
        key: "analytics",
        label: "Analytics",
        icon: "ri:bar-chart-2-line",
        url: "/analytics",
        permission: "analytics",
    },
    {
        key: "assistant-insights",
        label: "Assistant Insights",
        icon: "ri:robot-2-line",
        url: "/assistant-insights",
        permission: "assistantInsights",
    },
    {
        key: "users",
        label: "Users",
        icon: "ri:group-line",
        url: "/users",
        permission: "users",
    },
    {
        key: "account-deletions",
        label: "Deletion Requests",
        icon: "ri:user-unfollow-line",
        url: "/account-deletions",
        permission: "accountDeletion",
    },
    {
        key: "waitlist",
        label: "Waitlist",
        icon: "ri:list-check-2",
        url: "/waitlist",
        permission: "waitlist",
    },
    {
        key: "bulk-tools",
        label: "Bulk Import/Export",
        icon: "ri:upload-cloud-2-line",
        url: "/bulk-tools",
        permission: BULK_TOOL_MODULES,
    },
    {
        key: "notifications",
        label: "Notifications",
        icon: "ri:notification-3-line",
        url: "/notifications",
        permission: "notifications",
    },
    {
        key: "marketplace-group",
        label: "Marketplace",
        icon: "ri:shopping-bag-line",
        children: [
            {
                key: "product",
                label: "Product",
                icon: "ri:package-line",
                url: "/product",
                permission: "product",
            },
            {
                key: "brand",
                label: "Brand",
                icon: "ri:box-line",
                url: "/brand",
                permission: "brand",
            },
            {
                key: "category",
                label: "Category",
                icon: "ri:list-check-2",
                url: "/category", // list page
                permission: "category",
            },
            {
                key: "product-coupon",
                label: "Product Coupon",
                icon: "ri:ticket-2-line",
                url: "/product-coupon",
                permission: "coupon",
            },
        ],
    },
    // dynamic route, hidden from static menu
    {
        key: "category-details",
        label: "Category Details",
        icon: "ri:file-text-line",
        url: "/category/:id",
        permission: "category",
    },
    {
        key: "goals-group",
        label: "Goals",
        icon: "ri:flag-line",
        children: [
            {
                key: "goal-category",
                label: "Goal Category",
                icon: "ri:flag-line",
                url: "/goal-category",
                permission: "goalCategory",
            },
            {
                key: "custom-goal",
                label: "Custom Goal",
                icon: "ri:target-line",
                url: "/custom-goal",
                permission: "customGoal",
            },
        ],
    },
    {
        key: "content-group",
        label: "Content",
        icon: "ri:file-text-line",
        children: [
            {
                key: "banner",
                label: "Banner",
                icon: "ri:image-line",
                url: "/banner",
                permission: "banner",
            },
            {
                key: "feature",
                label: "Feature",
                icon: "ri:star-line",
                url: "/pages/faqs",
                permission: "faq",
            },
        ],
    },
    {
        key: "blog-group",
        label: "Blog",
        icon: "ri:newspaper-line",
        children: [
            {
                key: "blog-category",
                label: "Blog Category",
                icon: "ri:book-open-line",
                url: "/blog-category",
                permission: "blogCategory",
            },
            {
                key: "blog-subcategory",
                label: "Blog Sub-category",
                icon: "ri:stack-line",
                url: "/blog-subcategory",
                permission: "blogSubCategory",
            },
            {
                key: "blog-posts",
                label: "Blog Posts",
                icon: "ri:newspaper-line",
                url: "/blog-posts",
                permission: "blogPost",
            },
            {
                key: "blog-comments",
                label: "Blog Comments",
                icon: "ri:chat-3-line",
                url: "/blog-comments",
                permission: "blogComment",
            },
        ],
    },
    {
        key: "rewards-group",
        label: "Rewards",
        icon: "ri:gift-line",
        children: [
            {
                key: "reward-coupons",
                label: "Reward Coupons",
                icon: "ri:coupon-3-line",
                url: "/reward-coupons",
                permission: "rewardCoupons",
            },
            {
                key: "scratch-rules",
                label: "Scratch Card Rules",
                icon: "ri:sparkling-line",
                url: "/scratch-rules",
                permission: "rewardRules",
            },
            {
                key: "referrals",
                label: "Referrals",
                icon: "ri:user-add-line",
                url: "/referrals",
                permission: "referral",
            },
        ],
    },
    {
        key: "billpay-group",
        label: "Recharge & Bills",
        icon: "ri:smartphone-line",
        children: [
            {
                key: "billpay-charges",
                label: "Convenience Fees",
                icon: "ri:percent-line",
                url: "/billpay-charges",
                permission: "billpayCharges",
            },
            {
                key: "billpay-orders",
                label: "Orders",
                icon: "ri:bill-line",
                url: "/billpay-orders",
                permission: "billpayOrders",
            },
            {
                key: "billpay-invoices",
                label: "Invoices",
                icon: "ri:file-list-3-line",
                url: "/billpay-invoices",
                permission: "billpayInvoices",
            },
            {
                key: "billpay-settings",
                label: "Settings",
                icon: "ri:settings-3-line",
                url: "/billpay-settings",
                permission: "billpaySettings",
            },
        ],
    },
    {
        key: "voucher-offers",
        label: "Voucher Offers",
        icon: "ri:price-tag-3-line",
        url: "/voucher-offers",
        permission: "voucherOffers",
    },
    {
        key: "spend-tracker",
        label: "Spend Tracker",
        icon: "ri:trending-up-line",
        url: "/spend-tracker",
        permission: "spendTrackerCategory",
    },
];
